import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

const AdminLogin = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("villaalamlembongan@gmail.com");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back.");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error(
                err?.response?.data?.detail || "Login failed. Try again."
            );
        } finally {
            setLoading(false);
        }
    };

    const inputCls =
        "w-full bg-transparent border-b border-border py-3 pl-7 focus:outline-none focus:border-primary transition-colors font-body rounded-none";

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen flex items-center justify-center bg-muted px-6 py-32 relative"
        >
            <div className="absolute inset-0 opacity-30 pointer-events-none">
                <img
                    src="https://images.pexels.com/photos/36965360/pexels-photo-36965360.jpeg"
                    alt=""
                    className="w-full h-full object-cover"
                />
            </div>
            <div className="relative w-full max-w-md bg-card border border-border p-10 lg:p-12 shadow-sm">
                <div className="overline text-secondary">Villa Alam</div>
                <h1 className="font-display text-4xl font-light text-primary mt-2 tracking-tight">
                    Admin Access
                </h1>
                <p className="mt-3 text-sm text-muted-foreground font-light">
                    Sign in to manage guest enquiries and messages.
                </p>

                <form onSubmit={submit} className="mt-10 space-y-8" data-testid="admin-login-form">
                    <label className="block relative">
                        <div className="overline text-muted-foreground mb-2 text-[10px]">
                            Email
                        </div>
                        <Mail
                            size={15}
                            className="absolute left-0 bottom-3 text-muted-foreground"
                        />
                        <input
                            data-testid="admin-email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={inputCls}
                        />
                    </label>
                    <label className="block relative">
                        <div className="overline text-muted-foreground mb-2 text-[10px]">
                            Password
                        </div>
                        <Lock
                            size={15}
                            className="absolute left-0 bottom-3 text-muted-foreground"
                        />
                        <input
                            data-testid="admin-password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={inputCls}
                        />
                    </label>
                    <button
                        data-testid="admin-login-submit"
                        type="submit"
                        disabled={loading}
                        className="w-full inline-flex items-center justify-center gap-3 px-10 py-4 bg-primary text-white text-xs tracking-[0.2em] uppercase hover:bg-secondary transition-colors disabled:opacity-60"
                    >
                        {loading ? "Signing in…" : "Sign In"}
                        <ArrowRight size={14} />
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
